<div class="container-fluid text-center">
  <h3>Confirm Booking</h3>
  <!-- <error-message [message]="errorMessage"></error-message> -->

  <div>
    <ng-container *ngIf="siteVisit">
      <div class="title">
        {{ siteVisit.title }}
      </div>

      <div class="">{{ siteVisit.county }} <span *ngIf="siteVisit.county && siteVisit.state">,</span> {{ siteVisit.state }}</div>

      <div>
        {{ siteVisit.startDateTime | date: "short" }}

        <div class="date-sep">
          <i class="fa fa-chevron-right"></i>
        </div>

        {{ siteVisit.endDateTime | date: "short" }}
      </div>
    </ng-container>
  </div>

  <div class="btn-continue">
    <button
      type="button"
      class="btn btn-primary btn-lg btn-lg-round btn-block "
      [disabled]="loading || !confirmEnabled"
      (click)="confirmBooking()"
    >
      <i *ngIf="loading" class="fa fa-circle-notch fa-spin"></i>
      Confirm
    </button>
  </div>
</div>
